<template>
  <div class="group-bd ub">
    <label :style="{width:labelWidth, marginRight: labelRight}">{{title}}</label>
    <div class="ub-f1">
      <!--文本-->
      <p v-if="type === 'text'">{{currentValue}}</p>
      <!--输入框-->
      <input v-if="type === 'input'" type="text" v-model="currentValue" v-bind:ininput="onEmit()"
             :placeholder="placeholder">
      <i v-if="type === 'input'" class="icon icon-delete" @click="clear()" v-show="currentValue"></i>
      <!--选择框-->
      <div v-if="type === 'select'" class="select" @click="selected()" :class="{has:currentValue}">{{currentValue||
        placeholder}}<i class="icon icon-down centerY"></i></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "tGroup",
    props: {
      type: { type: String, default: 'input' }, //input,text,select
      title: { type: String, },
      placeholder: { type: String, },
      labelWidth: { type: String, default: 'auto' },
      labelAlign: { type: String, default: 'left' },
      labelRight: { type: String, default: '0' },
      value: [String, Number],
    },
    data() {
      return {
        currentValue: this.value,
      }
    },
    watch: {
      value: function () {
        this.currentValue = this.value;
      },
    },
    computed: {},
    methods: {
      onEmit() {
        this.$emit('input', this.currentValue);
        this.$emit('change');
      },
      clear() {
        this.currentValue = '';
        this.$emit('input', this.currentValue);
      },
      selected() {
        this.$emit('select');
      },
    }
  }
</script>

<style lang="scss">
  @import "../style/mixin";

  .group-bd {
    ::-webkit-input-placeholder {
      color: #B0B1AC;
      font-weight: normal;
    }
    padding: 0.1rem;
    @include border-1px-b(#D9D9D9);
    label {
      line-height: 0.24rem;
      font-size: 0.15rem;
      color: #202020;
    }
    .ub-f1 {
      position: relative;
      input {
        width: 100%;
        border: none;
        height: 0.24rem;
        padding: 0.04rem;
        line-height: 0.16rem;
        font-size: 0.15rem;
        outline: none;
      }
      p {
        font-size: 0.15rem;
        color: #202020;
        line-height: 0.24rem;
      }
      .select {
        font-size: 0.15rem;
        color: #B0B1AC;
        line-height: 0.24rem;
        position: relative;
        &.has {
          color: #202020;
        }
        i {
          right: -0.04rem;
          font-size: 0.15rem;
          color: #dedede;
        }
      }
      .icon-delete {
        position: absolute;
        top: 0;
        right: 0;
        padding: 0 0.02rem;
        line-height: 0.24rem;
        font-size: 0.15rem;
        z-index: 2;
        color: #dedede;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/group.vue